// extracted by mini-css-extract-plugin
module.exports = {"mottos":"TopMottos_mottos__ulXYS"};